// extracted by mini-css-extract-plugin
export default {"text":"LinkForgottenPassword_text__vncxP","link":"LinkForgottenPassword_link__Ci6vc"};